'use client';

import Image from 'next/image';
import { motion } from 'framer-motion';
import { useIsDesktop } from '@/shared/lib/react/useIsDesktop';
import { Typography } from '@/shared/ui/atoms';
import { SectionTitle } from '@/widgets/landing/medicontents/ui/molecules';
import * as S from './styles';

const ProcessSection = () => {
  const isLg = useIsDesktop();
  const baseImageUrl = process.env.NEXT_PUBLIC_BASE_IMAGE_URL;
  const contents = [
    {
      title: '간단한 입력',
      description: '치료사진과 함께\n간단한 설명 입력이면 끝',
      image: `${baseImageUrl}/medicontents/landing/process01.png`
    },
    {
      title: '퍼스널 브랜딩 설계',
      description: '병원의 강점을 찾아\n경쟁력 있는 스토리 완성',
      image: `${baseImageUrl}/medicontents/landing/process02.png`
    },
    {
      title: '완벽한 원고, 스토리 텔링',
      description: '완성된 초안 확인 후\n원클릭 승인',
      image: `${baseImageUrl}/medicontents/landing/process03.png`
    },
    {
      title: '고품질 메디컨텐츠 업로드',
      description: '블로그, 홈페이지, 플랫폼 등\n자동 업로드',
      image: `${baseImageUrl}/medicontents/landing/process04.png`
    }
  ];
  return (
    <section id="process-section" className={S.section}>
      <div className={S.Wrapper}>
        <SectionTitle eyebrow={{ text: `리뷰웍스의`, gap: 'mb-1' }} title={{ text: `간편한 전용 시스템으로\n운영되는 의료 마케팅`, color: 'text-[#F9FAFB]' }} />
        <motion.div
          initial={{ y: 55, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.7, ease: 'easeOut', delay: 0 }}
          className={S.motionWrap}
        >
          {contents.map((content, index) => (
            <div key={index} className={S.card}>
              <Typography as="p" className={S.indexBadge}>
                {index + 1}
              </Typography>
              <div className={S.thumbWrap}>
                <Image src={content.image} alt={content.title} fill sizes="100%" objectFit="cover" />
              </div>
              <div className={S.textBlock}>
                <Typography as="p" className={S.title}>
                  {content.title}
                </Typography>
                <Typography as="p" className={S.description}>
                  {content.description}
                </Typography>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ProcessSection;
